import styled from 'styled-components'

import { _3XL_Bold, mainColors, medias } from '@avantstay/backoffice-core'

import { IContainerProps, IRow } from '@new/__global/components/Section/_types'

export const Row = styled.div<IRow>`
  display: flex;
  margin-bottom: 26px;
  align-items: flex-start;
  flex-flow: wrap;

  ${props =>
    props.center &&
    `
    justify-content: center;
    align-items: center;

    ${medias.MD_SCREEN`
      justify-content: flex-start;
    `}
  `}

  ${medias.MD_SCREEN`
    align-items: center;
    flex-flow: row;
  `}
`

export const Title = styled.div`
  ${_3XL_Bold};
  position: relative;
  min-width: max-content;
  padding-right: 6px;
  width: 100%;
`

export const Container = styled.section<IContainerProps>`
  width: 100%;
  padding: 20px 16px;
  display: flex;
  flex-direction: column;
  flex: 1;
  background: ${mainColors.white};
  max-width: 100vw;
  margin-bottom: 10px;

  ${medias.MD_SCREEN`
    padding: 30px 40px;
    margin-bottom: 0;
  `}

  ${props =>
    props.full &&
    `
    width: 100%;
    overflow-x: hidden;

      ${medias.MD_SCREEN`
      width: 100%;
    `}
  `}

  ${props =>
    props.scrollable &&
    `
    overflow-y: auto;
    margin: 0;
    padding: 0 20px;
  `}
`
